import { fetchApi } from '../api/digitalVault';
import { parseFiles, parseFolders, parsePaginationManual } from '../utils';
const getUserTrash = async (params = {}, logger) => {
    const { order = ['asc'], sort, uri = 'dv-user://{userId}', ...rest } = params;
    const { trashCan } = await fetchApi({
        ...rest,
        ...(sort && { sort: `${sort}+${order}` }),
        uri,
    }, 'uri/trash', {}, false, logger);
    const { file, folder, '@totalCount': total } = trashCan;
    const { hasNextPage, nextPageParams } = parsePaginationManual(params, parseInt(total));
    return {
        hasNextPage,
        data: [
            ...parseFolders({ folder: folder }),
            ...parseFiles({ file: file }),
        ],
        paginate: () => {
            return hasNextPage && getUserTrash(nextPageParams, logger);
        },
    };
};
export default getUserTrash;
